import React from 'react';
import { Form, Input, Select } from 'antd';
import { BookOutlined, BankOutlined, TrophyOutlined } from '@ant-design/icons';
import {
  HIGHEST_EDUCATION_OPTIONS,
  AL_STREAM_OPTIONS
} from '../../../../Utils/sriLankaGeoData';

const { Option } = Select;
const { TextArea } = Input;

const Section04Education = () => {
  return (
    <div className="section-container">
      <div className="section-header">
        <span className="section-badge">SECTION 04</span>
        <h3>Education & Professional Qualifications</h3>
        <p className="section-description">
          Please outline your academic background and any professional credentials you have achieved or are currently pursuing.
        </p>
      </div>

      <div className="form-grid">
        <div className="grid-two-cols">
          <Form.Item
            label="Highest Educational Qualification"
            name="highestEducation"
            rules={[{ required: true, message: 'Please select your highest educational qualification' }]}
          >
            <Select size="large" placeholder="Select highest qualification" showSearch>
              {HIGHEST_EDUCATION_OPTIONS.map((opt) => (
                <Option key={opt} value={opt}>
                  {opt}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="School / University / Institute"
            name="instituteName"
            rules={[{ required: true, message: 'Please enter your school, university, or institute name' }]}
          >
            <Input prefix={<BankOutlined />} placeholder="e.g. Royal College / University of Colombo" size="large" />
          </Form.Item>
        </div>

        <div className="grid-two-cols">
          <Form.Item label="G.C.E. A/L Stream (Optional)" name="alStream">
            <Select size="large" placeholder="Select A/L stream" allowClear>
              {AL_STREAM_OPTIONS.map((st) => (
                <Option key={st} value={st}>
                  {st}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Degree / Diploma Title (Optional)" name="degreeDiploma">
            <Input prefix={<BookOutlined />} placeholder="e.g. B.Sc. in Accounting / Diploma in IT" size="large" />
          </Form.Item>
        </div>

        <Form.Item
          label="Professional Qualifications Completed (Optional)"
          name="professionalQualifications"
          extra="e.g. CIMA Passed Finalist, ACCA Member, CA Sri Lanka Certificate, CIM, SLIM, AAT"
        >
          <Input prefix={<TrophyOutlined />} placeholder="e.g. CIMA Cert BA, AAT Finalist" size="large" />
        </Form.Item>

        <Form.Item
          label="Professional Qualification Currently Following (Optional)"
          name="currentlyFollowingQualifications"
        >
          <Input placeholder="e.g. CIMA Operational Level, MBA in Logistics, ACCA Skill Level" size="large" />
        </Form.Item>

        <Form.Item
          label="Other Qualifications / Certificates (Optional)"
          name="otherQualifications"
        >
          <TextArea rows={2} placeholder="Any other relevant short courses, diplomas, or vocational certifications" />
        </Form.Item>
      </div>
    </div>
  );
};

export default Section04Education;
